import React from "react";
import { Button, Space } from "@src/components/nessie-web";
import Translate from "@src/components/translation/Translate";

const DownloadAppButton = ({ buttonHref, translationPath }: { buttonHref: string; translationPath: string }) => {
  return (
    <div css={{ padding: "15px 10px" }}>
      <Button href={buttonHref} kind="secondary" size="s">
        <Translate path={translationPath} />
      </Button>
    </div>
  );
};

export default DownloadAppButton;
